import { Link } from "react-router-dom";
import LockIcon from "@/assets/images/lock.png";
import { Container, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

/**
 * In-layout lock pane shown to unsubscribed operators (sidebar + banner remain visible).
 * Directs the owner to choose a plan under Payments › Subscriptions.
 */
export const SubscriptionRequired = ({ className }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      data-testid="subscription-required-page"
      className={clsx("flex flex-1 bg-city bg-contain bg-[center_bottom_-2rem] bg-no-repeat", className)}
    >
      <Container className="flex max-w-md flex-col items-center px-5 pb-32 pt-[14vh]">
        <img src={LockIcon} alt="Subscription Required" className="max-w-[128px]" />
        <Typography variant="title" className="mb-4 !text-[24px] sm:!text-[32px]">
          Subscription Required
        </Typography>
        <Typography variant="paragraph" className="text-center text-neutral-dark-gray">
          Your subscription has ended. To continue using RideMinder and access your account, please choose a plan under Payments &gt;{" "}
          <Link to="/payments/subscriptions" className="font-semibold text-primary underline">
            Subscriptions
          </Link>
          .
        </Typography>
        <Typography variant="paragraph" className="mt-16 text-center text-neutral-silver-gray">
          If you&apos;re experiencing any issues, please contact{" "}
          <a href="mailto:support@rideminder.com" className="underline">
            support@rideminder.com
          </a>
        </Typography>
      </Container>
      <div className="pointer-events-none fixed bottom-0 min-h-[50%] w-full bg-city bg-cover bg-no-repeat" />
    </div>
  );
};
